<template>
  <div>
    <v-card flat color="background rounded-xl">
      <v-card-text>
        <h2 class="mb-2">Kontroller alapinfók:</h2>
        <div v-if="basicInfo">
          <ul>
            <li v-for="(part, index) in basicInfo" :key="index">{{ part }}</li>
          </ul>
        </div>
        <div v-else>
          <p>Nincs elérhető információ a DS Controller állapotáról.</p>
        </div>

        <v-data-table
          :headers="datatable.headers"
          :items="healthLogs"
          class="elevation-1 mt-4 rounded-xl"
          hide-default-footer
          dense
        />

        <v-divider class="my-6" />

        <div class="d-flex align-center">
          <v-text-field
            label="Kártya jogosultság ellenőrzés"
            dense
            v-model="cardNumber"
            filled
            hide-details
          >
          </v-text-field>
          <v-btn color="primary" class="ml-3 rounded-xl" depressed fab small @click="fetchCardInfo">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </div>

        <v-divider class="my-6" v-if="cardQueryLog"></v-divider>

        <div v-if="cardQueryLog">
          <h2 class="mb-3">Kártya ellenőrzés eredménye:</h2>
          <v-card outlined class="mb-3 rounded-lg">
            <v-card-title class="subtitle-1 font-weight-bold">
              Log ID: {{ cardQueryLog.log_id }} |
              {{ cardQueryLog.found ? 'Kártya megtalálva' : 'Kártya nem található' }}
            </v-card-title>
            <v-card-text>
              <pre class="body-2" style="font-family: monospace">{{ cardQueryLog.result }}</pre>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'DSCDebug',

  props: {
    controller: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      statusInterval: null,
      basicInfo: {},
      healthLogs: [],
      cardNumber: '',
      cardQueryLog: null,
      datatable: {
        headers: [
          { text: 'ID', value: 'logid', sortable: false },
          { text: 'Üzenet', value: 'message', sortable: false },
          { text: 'Típus', value: 'type', sortable: false },
          { text: 'Időpont', value: 'timestamp', sortable: false },
        ],
      },
    };
  },

  mounted() {
    this.statusInterval = setInterval(this.fetchControllerStatus, 5000);
    this.fetchControllerStatus();
  },

  methods: {
    async fetchControllerStatus() {
      try {
        const response = await this.$http.get(
          `/controllers/ds-controller-status/?element_id=${this.controller.element_id}&controller_serial_number=${this.controller.serial_number}`
        );
        this.basicInfo = response.controller_basic_information || {};
        this.healthLogs = response.controller_health_logs || {};
      } catch (error) {
        console.error('Hiba a DS Controller információ lekérésekor:', error);
      }
    },

    async fetchCardInfo() {
      if (!this.cardNumber) {
        return;
      }

      try {
        const response = await this.$http.get(
          `/controllers/dsc-check-card/?element_id=${
            this.controller.element_id
          }&card_number=${this.cardNumber.trim()}`
        );
        this.cardQueryLog = response.card_query_log;
      } catch (error) {
        console.error('Hiba a kártya információ lekérésekor:', error);
        this.$toast.error('Hiba történt a kártya információ lekérésekor.');
      }
    },
  },
};
</script>
